// export const dateFormat = (date) => {
//   const dateTime = new Date(date); // Create a Date object representing the current date and time

//   const year = dateTime.getFullYear(); // Get the year (e.g., 2023)
//   const month = dateTime.getMonth() + 1; // Get the month (0-11, so add 1 to get 1-12)
//   const day = dateTime.getDate(); // Get the day of the month (1-31)

//   return `${day}-${month}-${year}`;
// };

// export const getTime = (date_) => {
//   const date = new Date(date_);
//   // Get the time components
//   const hours = date.getUTCHours();
//   const minutes = date.getUTCMinutes();
//   const seconds = date.getUTCSeconds();
//   const milliseconds = date.getUTCMilliseconds();

//   return `${hours}:${minutes} `;
// };


// Function to format the date
// export const dateFormat = (date) => {
//   const dateTime = new Date(date);

//   const year = dateTime.getFullYear();
//   const month = String(dateTime.getMonth() + 1).padStart(2, '0');
//   const day = String(dateTime.getDate()).padStart(2, '0');

//   return `${day}-${month}-${year}`;
// };

// // Function to get the time in AM/PM format
// export const getTime = (date_) => {
//   const date = new Date(date_);

//   let hours = date.getHours();
//   const minutes = String(date.getMinutes()).padStart(2, '0');
//   const ampm = hours >= 12 ? 'PM' : 'AM';

//   hours = hours % 12;
//   hours = hours ? hours : 12; // The hour '0' should be '12'

//   return `${hours}:${minutes} ${ampm}`;
// };


// Function to format the date
export const dateFormatting = (date) => {
  const dateTime = new Date(date);

  const year = dateTime.getFullYear();
  const month = String(dateTime.getMonth() + 1).padStart(2, '0');
  const day = String(dateTime.getDate()).padStart(2, '0');

  return `${day}-${month}-${year}`;
};

// Function to get the time in AM/PM format
export const getTime = (date_) => {
  const date = new Date(date_);

  let hours = date.getHours();
  const minutes = String(date.getMinutes()).padStart(2, '0');
  const ampm = hours >= 12 ? 'PM' : 'AM';

  hours = hours % 12;
  hours = hours ? hours : 12; // The hour '0' should be '12'

  return `${hours}:${minutes} ${ampm}`;
};


export const dateFormatForm = (date) => {
  if (!date) return "";

  const dateTime = new Date(Number(date)); // ensures compatibility with timestamps
  if (isNaN(dateTime.getTime())) return ""; // handle invalid date

  const year = dateTime.getFullYear();
  const month = String(dateTime.getMonth() + 1).padStart(2, "0");
  const day = String(dateTime.getDate()).padStart(2, "0");

  return `${day}-${month}-${year}`;
};


// // Example usage
// const date = '2024-06-14T16:30:03.895Z';

// console.log(dateFormat(date)); // Outputs: 14-06-2024





// Function to format the date and time
export const dateFormat = (date) => {
  const dateTime = new Date(date);

  // Get the date components
  const year = dateTime.getFullYear();
  const month = String(dateTime.getMonth() + 1).padStart(2, '0');
  const day = String(dateTime.getDate()).padStart(2, '0');

  // Get the time components
  let hours = dateTime.getHours();
  const minutes = String(dateTime.getMinutes()).padStart(2, '0');
  const ampm = hours >= 12 ? 'PM' : 'AM';

  hours = hours % 12;
  hours = hours ? hours : 12; // The hour '0' should be '12'

  const formattedDate = `${day}-${month}-${year}`;
  const formattedTime = `${hours}:${minutes} ${ampm}`;

  return `${formattedDate} ${formattedTime}`;
};

// Example usage
const date = '2024-06-14T16:30:03.895Z';

console.log(dateFormat(date)); // Outputs: 14-06-2024 4:30 PM



export function convertTo12Hour(time) {

  console.log(time)
  if (typeof time !== 'string' || !time.includes(':')) {
    return 'Invalid time';
  }
  // Split the time into hours, minutes, and seconds
  let [hours, minutes, seconds] = time?.split(':').map(Number);


  if (isNaN(hours) || isNaN(minutes) || isNaN(seconds)) {
    return 'Invalid time';
  }

  // Determine AM or PM suffix
  let period = hours >= 12 ? 'PM' : 'AM';

  // Convert hours from 24-hour to 12-hour format
  hours = hours % 12 || 12;

  // Format the time string in 12-hour format with leading zeros if needed
  return `${hours}:${minutes.toString().padStart(2, '0')}:${seconds
    .toString()
    .padStart(2, '0')} ${period}`;
}


export const convertTimeToDateFormat = (timeString, dateString = null) => {
  // Use provided date or default to current date
  const date = dateString ? new Date(dateString) : new Date();

  // Combine date and time strings
  const dateTimeString = `${date.toISOString().split('T')[0]}T${timeString}`;

  // Create a Date object from the combined datetime string
  const dateObject = new Date(dateTimeString);

  // Extract date components
  const day = String(dateObject.getDate()).padStart(2, '0');
  const month = String(dateObject.getMonth() + 1).padStart(2, '0'); // Months are zero-indexed
  const year = String(dateObject.getFullYear()).slice(-2); // Get last two digits of the year

  // Format date to dd-mm-yy
  const formattedDate = `${day}-${month}-${year}`;

  return formattedDate;
};

// Example usage
// const timeString = "12:41:07";
// console.log(convertTimeToDateFormat(timeString)); // Using current date
// console.log(convertTimeToDateFormat(timeString, "2024-06-26")); // Using specific date


// const timeString = "12:41:07";
// console.log(convertTimeToDateFormat(timeString)); // Output: "26-06-24"


export const convertTo12HourFormat = (time) => {
  // Split the time string into parts
  let [hours, minutes, seconds] = time.split(':').map(Number);

  // Determine the period (AM/PM)
  let period = hours >= 12 ? 'PM' : 'AM';

  // Convert hours to 12-hour format
  hours = hours % 12 || 12; // Convert 0 to 12 for 12 AM

  // Format minutes and seconds with leading zeros if necessary
  minutes = minutes.toString().padStart(2, '0');
  seconds = seconds.toString().padStart(2, '0');

  // Construct the formatted time string
  let formattedTime = `${hours}:${minutes}:${seconds} ${period}`;

  return formattedTime;
}

// Example usage
let time24 = "15:53:04";
let time12 = convertTo12HourFormat(time24);
console.log(time12); // Output: 3:53:04 PM


export const formatDate = (date) =>
  date ? new Date(date).toISOString().split("T")[0] : "";
